import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('BankService', BankService);

  BankService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'TranslationModalService',
    'BankModalService',
    'WindowModalService',
    'SessionService',
  ];

  function BankService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    TranslationModalService,
    BankModalService,
    WindowModalService,
    SessionService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'banks';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getBanks: getBanks,
      getBank: getBank,
      saveBank: saveBank,
      openBankTranslations: openBankTranslations,
      deleteBank: deleteBank,
      changeBankStatus: changeBankStatus,
      updateBanks: updateBanks,
      openBanksModal: openBanksModal,
      openBankModal: openBankModal,
      parseBankIds: parseBankIds,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filter = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filter;
    }

    function getBanks(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getBank(id, language, translate) {
      var params = { lang: null, get: null };

      if (language) {
        params.lang = language;
      }

      if (translate) {
        params.get = 'translate';
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveBank(item, language) {
      var method = item.id ? 'put' : 'post';
      var url = item.id ? apiUrl + '/' + item.id : apiUrl;

      var lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      function success(response) {
        var msg = item.id ? 'MODIFIED_BANK' : 'NEW_ADDED_BANK';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { bank: item, lang: lang }, success, failure);
    }

    function openBankTranslations(item, additionalLanguages) {
      var template = './app/ajs/banks/modals/bank-detail-translation.html';

      var modalParams = {
        title: item.name,
        item: item,
        additionalLanguages: additionalLanguages,
      };

      var initializeCallback = function (itemId, language) {
        return getBank(itemId, language, 'translate').then(function (data) {
          return data;
        });
      };

      var confirmCallback = function (item, language) {
        return saveBank(item, language).then(function (data) {
          if (!data.status) {
            return data.response;
          }

          return false;
        });
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }

    function deleteBank(item, successCallback) {
      var params = {
        title: 'DELETE_BANK',
        itemName: item.name,
        reason: 'DELETE_ITEM_REASON',
        confirmButtonLabel: 'DELETE_BANK',
        successMsg: 'DELETED_BANK',
      };

      var url = apiUrl + '/' + item.id;
      utils.deleteItem(url, successCallback, params);
    }

    function changeBankStatus(item) {
      utils.changeItemStatus(apiUrl + '/' + item.id, item);
    }

    function updateBanks(action, items, successCallback) {
      utils.updateItems(apiUrl, action, items, successCallback);
    }

    function openBanksModal(getItemsCallback) {
      BankModalService.openBanks(getItemsCallback);
    }

    function openBankModal(item, defaultLanguage, additionalLanguages, mode, getItemsCallback) {
      var templateUrl = './app/ajs/banks/modals/bank-detail-modal.html';

      var originalItem = angular.copy(item);

      var modalParams = {
        title: !item.id ? 'CREATE_BANK' : 'BANK_DETAILS',
        item: originalItem,
        mode: mode,
        defaultLanguage: defaultLanguage,
        additionalLanguages: additionalLanguages,
        closeOnSave: false,
      };

      if (!item.id) {
        modalParams.closeOnSave = true; // Close modal after create
      }

      var confirmCallback = function (selectedItem) {
        if (item.id) {
          // Edit
          item.name = selectedItem.name;
          item.account_catalog_code = selectedItem.account_catalog_code;
          item.description = selectedItem.description;
          item.type = selectedItem.type;

          return utils.itemListChanged(selectedItem.id);
        }

        return getItemsCallback(selectedItem);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function parseBankIds(checkedBank) {
      var banknIdsChecked = []; // array
      for (var key in checkedBank) {
        if (checkedBank[key]) {
          // Add only true values to objet
          banknIdsChecked.push(key); // key
        }
      }

      return banknIdsChecked;
    }
  }
})();
